import { Injectable, Injector } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';
import { DocumentListDataService } from '@fi-app/document/document-list-data-service';
import { MediaBankListDataService } from '@fi-app/media-bank/media-bank-list-data.service';
import { ChecklistListDataService } from '@fi-app/checklist/list/checklist-list-data.service';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { IComponentRef } from '@fi-app/core/core';
import { DocumentListContainerComponent } from '@fi-app/document/document-list-container/document-list-container.component';
import { DocumentViewContainerComponent } from '@fi-app/document/document-view-container/document-view-container.component';
import { MediaBankListContainerComponent } from '@fi-app/media-bank/media-bank-list-container/media-bank-list-container.component';
import { MediaBankViewContainerComponent } from '@fi-app/media-bank/media-bank-view-container/media-bank-view-container.component';
import { ChecklistListContainerComponent } from '@fi-app/checklist/list/checklist-list-container/checklist-list-container.component';
import { DocumentViewService } from '@fi-app/document/document-view-service/document-view.service';
import { IChecklistListStateModel } from '@fi-app/checklist/checklist';
import { BehaviorSubject } from 'rxjs';
import { FiFormListExtendedSearchComponent } from '@fi-app/fi-form/fi-form-list-extended-search/fi-form-list-extended-search.component';
import { FiUserListExtendedSearchComponent } from '@fi-app/user/user-list/fi-user-list/fi-user-list-extended-search/fi-user-list-extended-search.component';
import { FiChecklist2ListExtendedSearchComponent } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list-extended-search/fi-checklist2-list-extended-search.component';
import { FiChecklist2AuditListExtendedSearchComponent } from '@fi-shared/checklist/fi-checklist2-audit/fi-checklist2-audit-list-extended-search/fi-checklist2-audit-list-extended-search.component';
import { MediaBankService } from '@fi-app/media-bank/media-bank.service';

export interface IExtendedSearchSettings {
    listSettings: {
        component: IComponentRef;
        listModel: () => ListData<any>;
        resolve: any;
    };
    viewSettings?: {
        resolve: any;
        component: IComponentRef;
    };
    filterPrams?;
}

@Injectable()
export class ExtendedSearchTypesService {
    private extendedSearchSettings: { [objectType: string]: IExtendedSearchSettings } = {};

    constructor(
        listViewSettingsService: ListViewSettingsService,
        documentListDataService: DocumentListDataService,
        mediaBankListDataService: MediaBankListDataService,
        checklistListDataService: ChecklistListDataService,
        documentViewService: DocumentViewService,
        mediaBankService: MediaBankService,
        injector: Injector,
    ) {
        this.extendedSearchSettings[ObjectTypes.Document] = {
            listSettings: {
                listModel: () => documentListDataService.getInstance(),
                component: DocumentListContainerComponent,
                resolve: {
                    DocumentTemplateRootStateModel: {},
                    documentListViewSettings: () => {
                        return listViewSettingsService.getSetting(ObjectTypes.Document);
                    },
                },
            },
            viewSettings: {
                component: DocumentViewContainerComponent,
                resolve: (viewModel) => {
                    return documentViewService.prepareEverythingForViewFromExtendedSearch(viewModel.Id);
                },
            },
        };

        this.extendedSearchSettings[ObjectTypes.MediaBank] = {
            listSettings: {
                listModel: () => mediaBankListDataService.getInstance(),
                component: MediaBankListContainerComponent,
                resolve: {
                    mediaListViewSettings: () => {
                        return listViewSettingsService.getSetting(ObjectTypes.MediaBank);
                    },
                },
            },
            viewSettings: {
                component: MediaBankViewContainerComponent,
                resolve: (viewModel) => {
                    return {
                        mediaBankFile: viewModel,
                        isFromMediaBankModalDialog: true,
                    };
                },
            },
        };

        this.extendedSearchSettings[ObjectTypes.CheckList] = {
            listSettings: {
                listModel: () => checklistListDataService.getExtendedSearchInstance(),
                component: ChecklistListContainerComponent,
                resolve: {
                    checklistListStateModel: <IChecklistListStateModel>{
                        listData$: new BehaviorSubject(null),
                    },
                },
            },
            viewSettings: null,
        };

        this.extendedSearchSettings[ObjectTypes.Form] = {
            listSettings: <any>{
                component: FiFormListExtendedSearchComponent,
            },
        };

        this.extendedSearchSettings[ObjectTypes.Checklist2] = {
            listSettings: <any>{
                component: FiChecklist2ListExtendedSearchComponent,
            },
        };
        this.extendedSearchSettings[ObjectTypes.Checklist2Audit] = {
            listSettings: <any>{
                component: FiChecklist2AuditListExtendedSearchComponent,
            },
        };

        this.extendedSearchSettings[ObjectTypes.User] = {
            listSettings: <any>{
                component: FiUserListExtendedSearchComponent,
            },
        };
    }

    public getExtendedSearchSettings(objectType) {
        return this.extendedSearchSettings[objectType];
    }
}
